var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('div',{staticClass:"error-bg"},[_c('p',{staticClass:"err-title"},[_vm._v("404")]),_c('p',{staticClass:"err-msg"},[_vm._v("对不起,   您的页面出去旅行了~")])])])
}]

export { render, staticRenderFns }